import { last } from 'lodash';

import { useTrackingContext } from '@zapier/toolbox-tracking';

import { useFormContext } from 'app/get-help/contexts/FormContext';

import { EVENT_CONTACT_INIT, EVENT_CONTACT_STEP } from 'app/get-help/constants';

const useTrackPath = () => {
  // can't `useRef` here as we need this to be stateful between `useTrackPath` instances.
  const { lastTrackedPath, setLastTrackedPath } = useFormContext();

  // can't move this to `FormContext` completely as tracking context relies on `FormContext`
  const { trackEvent } = useTrackingContext();

  const trackPath = async (nodePath: string, additionalPath?: string) => {
    const crumbs = nodePath.split('.');

    if (last(crumbs) === 'help') {
      // drop help as that node is a container of several steps
      crumbs.pop();

      // first of which is confirming the answers, but only if we have more than just the topic question
      if (last(crumbs) !== 'topic') {
        crumbs.push('confirm');
      }
    }

    if (additionalPath) {
      crumbs.push(additionalPath);
    }

    const path = crumbs.join('.');

    if (lastTrackedPath !== path) {
      const eventName = lastTrackedPath
        ? EVENT_CONTACT_STEP
        : EVENT_CONTACT_INIT;

      // This is a call to the v3 events endpoint, which will soon be deprecated
      trackEvent(eventName, {
        path,
      });

      // Historically, we've tracked two types of events related to the `path` a
      // user follows as they navigate through the contact form:
      // 1. When the contact form is opened: EVENT_CONTACT_STEP
      // 2. When a node/step is selected: EVENT_CONTACT_INIT
      if (eventName === EVENT_CONTACT_INIT) {
        // TODO: Similar to the comment below this block,
        // I will come back and clean this up in another MR, pending
        // some conversations with support-data-pod
        return;
      } else {
        // Emit a UserInteractionEvent

        // TODO: In another MR (under this same card), I will:
        // - change this so that we use `emit` instead of `trackEvent`
        // - update the logic so that correctly sends the required data to the new endpoint. Currently
        // the L1/category value is sent, but nothing for L2 or L3
        trackEvent(
          'schema:web_analytics.tracking.user_interaction.UserInteractionEvent',
          {
            system_name: 'support_contact_form',
            interaction_name: eventName.split(' ').join('_').replace(':', ''),
            option_selected: path,
            event_action: 'click',
          }
        );
      }
      setLastTrackedPath(path);
    }
  };

  return trackPath;
};

export default useTrackPath;
